module.exports = __webpack_public_path__ + "img/home_huodong.87ba4bc8.png";